import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle2, Heart } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-[#0A0A23] pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-94">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#E07AF0] rounded-full opacity-5 blur-[120px] translate-x-1/2 -translate-y-1/4" data-id="element-95" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[#E07AF0] rounded-full opacity-5 blur-[100px] -translate-x-1/2 translate-y-1/2" data-id="element-96" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-97">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-98">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-99">
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-4" data-id="element-100">
              Transformá tu relación{' '}
              <span className="text-[#E07AF0] italic" data-id="element-101">de raíz</span>
            </h1>

            <p className="text-xl text-[#E07AF0] font-serif italic mb-8" data-id="element-102">
              El manual que te enseña a amar de forma consciente, comunicarte
              sin herir y construir un vínculo inquebrantable.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-6" data-id="element-103">
              <Button size="lg" icon scrollTo="oferta" data-id="element-104">
                QUIERO EL MANUAL
              </Button>
            </div>

            <div className="flex items-center gap-2 mb-6 justify-center lg:justify-start" data-id="element-105">
              <div className="flex -space-x-2" data-id="element-106">
                {['👩', '👨', '👩‍🦰', '👨‍🦱'].map((emoji, i) => <span key={i} className="w-7 h-7 rounded-full bg-[#1A1A40] border-2 border-[#0A0A23] flex items-center justify-center text-xs" data-id="element-107">
                    {emoji}
                  </span>)}
              </div>
              <span className="text-sm text-[#9090B0]" data-id="element-108">
                <span className="text-white font-semibold" data-id="element-109">+500 personas</span>{' '}
                ya lo están leyendo
              </span>
            </div>

            <p className="text-xs text-[#9090B0] uppercase tracking-wide flex items-center justify-center lg:justify-start gap-3 flex-wrap" data-id="element-110">
              <span className="flex items-center gap-1.5" data-id="element-111">
                <CheckCircle2 className="w-4 h-4 text-[#E07AF0]" data-id="element-112" /> Acceso
                inmediato
              </span>
              <span className="hidden sm:inline text-[#2A2A50]" data-id="element-113">•</span>
              <span className="flex items-center gap-1.5" data-id="element-114">
                <CheckCircle2 className="w-4 h-4 text-[#E07AF0]" data-id="element-115" /> Formato
                digital
              </span>
              <span className="hidden sm:inline text-[#2A2A50]" data-id="element-116">•</span>
              <span className="flex items-center gap-1.5" data-id="element-117">
                <CheckCircle2 className="w-4 h-4 text-[#E07AF0]" data-id="element-118" /> Garantía 7
                días
              </span>
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-119">
            <div className="absolute inset-0 bg-[#E07AF0] rounded-2xl transform rotate-3 opacity-10 blur-xl" data-id="element-120" />
            <div className="relative flex flex-col items-center gap-6" data-id="element-121">
              <img src="https://cdn.magicpatterns.com/uploads/gjfFxXFG4YqvMZTWJDEjDe/Mockup.png" alt="Vínculos de Hierro - Mockup del manual en tablet" className="w-full max-w-xs mx-auto drop-shadow-2xl" data-id="element-122" />

              <div className="w-full max-w-sm mx-auto" data-id="element-123">
                <p className="text-center text-xs uppercase tracking-widest text-[#E07AF0] font-semibold mb-3" data-id="element-124">
                  + 3 Bonus incluidos
                </p>
                <div className="grid grid-cols-3 gap-3" data-id="element-125">
                  <motion.img initial={{
                  opacity: 0,
                  y: 10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  duration: 0.5,
                  delay: 0.5
                }} src="https://cdn.magicpatterns.com/uploads/nzybojKY5VqVxTxgAJJdKG/Bonus_1.png" alt="Bonus 1 - Cómo frenar una pelea en 60 segundos" className="w-full rounded-lg shadow-lg shadow-[#E07AF0]/10 hover:scale-105 transition-transform duration-300" data-id="element-126" />
                  <motion.img initial={{
                  opacity: 0,
                  y: 10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  duration: 0.5,
                  delay: 0.65
                }} src="https://cdn.magicpatterns.com/uploads/117k2QL9vuB8ysdBw3Dv5B/Bonus_2.png" alt="Bonus 2 - 50 Preguntas para volver a conocernos" className="w-full rounded-lg shadow-lg shadow-[#E07AF0]/10 hover:scale-105 transition-transform duration-300" data-id="element-127" />
                  <motion.img initial={{
                  opacity: 0,
                  y: 10
                }} animate={{
                  opacity: 1,
                  y: 0
                }} transition={{
                  duration: 0.5,
                  delay: 0.8
                }} src="https://cdn.magicpatterns.com/uploads/r3EThU7NP3yCpnGv296KpT/Bonus_3.png" alt="Bonus 3 - El Mapa de Nuestra Casa" className="w-full rounded-lg shadow-lg shadow-[#E07AF0]/10 hover:scale-105 transition-transform duration-300" data-id="element-128" />
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}